import { MultilingualWidgetConfig } from '../dashboard.widgets.config';

interface SurveyOption {
  id: string;
  en: string;
  de: string;
}

interface SurveyQuestion {
  id: string;
  question: {
    en: string;
    de: string;
  };
  options: SurveyOption[];
  selectedOption: string | null;
}

const surveyQuestion: SurveyQuestion = {
  id: 'staff-burnout',
  question: {
    en: 'How would you rate your current workload stress level?',
    de: 'Wie würden Sie Ihren aktuellen Arbeitsbelastungsstress einschätzen?',
  },
  options: [
    {
      id: 'option1',
      en: 'Manageable - I have adequate resources and time',
      de: 'Bewältigbar - Ich verfüge über ausreichende Ressourcen und Zeit',
    },
    {
      id: 'option2',
      en: 'Moderate - Occasionally challenging but sustainable',
      de: 'Moderat - Gelegentlich herausfordernd, aber nachhaltig',
    },
    {
      id: 'option3',
      en: 'High - Frequently feeling overwhelmed',
      de: 'Hoch - Häufig überfordert',
    },
    {
      id: 'option4',
      en: 'Severe - Consistently overwhelmed and at risk of burnout',
      de: 'Schwerwiegend - Ständig überfordert und burnoutgefährdet',
    },
  ],
  selectedOption: null,
};

const generateSurveyHtml = (language: 'en' | 'de'): string => {
  return `
    <div style="display: flex; flex-direction: column; height: 100%; font-family: 'Be Vietnam Pro', sans-serif; color: #282a32;">
      <div style="margin-bottom: 16px; font-weight: 600; color: #282a32;">
        ${language === 'en' ? 'Staff Feedback Survey' : 'Mitarbeiter-Feedback-Umfrage'}
      </div>
      <div style="background-color: #fdfcff; padding: 16px; border-radius: 8px; border: 1px solid #eff1f6; margin-bottom: 16px;">
        <div style="font-weight: 500; margin-bottom: 12px;">${surveyQuestion.question[language]}</div>
        <div style="display: flex; flex-direction: column; gap: 10px;">
          ${surveyQuestion.options
            .map(
              option => `
              <label style="display: flex; align-items: center; cursor: pointer; padding: 8px; border-radius: 6px; transition: background-color 0.2s ease; hover:background-color: #f5f7fa;">
                <div style="position: relative; margin-right: 12px;">
                  <input type="radio" name="survey-${surveyQuestion.id}" value="${option.id}" style="appearance: none; width: 20px; height: 20px; border: 2px solid #d1d5db; border-radius: 50%; outline: none; margin: 0; cursor: pointer;" onchange="document.querySelector('#selected-option-${surveyQuestion.id}').textContent = '${option[language]}';">
                  <div style="position: absolute; top: 5px; left: 5px; width: 10px; height: 10px; border-radius: 50%; background-color: #4f46e5; opacity: 0; transition: opacity 0.2s ease;"></div>
                </div>
                <div style="font-size: 0.95rem;">${option[language]}</div>
              </label>`,
            )
            .join('')}
        </div>
      </div>
      <div style="margin-top: auto; display: flex; justify-content: space-between; align-items: center;">
        <div style="font-size: 0.85rem; color: #686b87;">
          ${language === 'en' ? 'Selected: ' : 'Ausgewählt: '}<span id="selected-option-${surveyQuestion.id}">-</span>
        </div>
        <button style="background-color: #4f46e5; color: white; border: none; border-radius: 6px; padding: 8px 16px; font-weight: 500; cursor: pointer; transition: background-color 0.2s ease;">
          ${language === 'en' ? 'Submit' : 'Absenden'}
        </button>
      </div>
    </div>`;
};

export const staffSurveyWidget: MultilingualWidgetConfig = {
  id: 'staff-survey',
  translations: {
    en: {
      title: 'Staff Wellness Survey',
      content: generateSurveyHtml('en'),
    },
    de: {
      title: 'Mitarbeiter-Wohlbefinden-Umfrage',
      content: generateSurveyHtml('de'),
    },
  },
  x: 0,
  y: 0,
  w: 3,
  h: 4,
};
